import merge from 'deepmerge';
import React from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import defaultTheme from '../../theme/default';
import GlobalStyle from '../GlobalStyle';
/**
 * Returns the value parameter converted to a string, if it's a zero;
 * otherwise returns the input parameter
 */
export var replacer = function (_, // eslint-disable-line @typescript-eslint/no-explicit-any
value) { return (value === 0 ? '0' : value); };
/**
 * Returns a clone of argument 'theme', having all zero values converted to strings
 * If there was no number converted at all, it returns the original theme object.
 */
export function replaceAllZerosWithStrings(theme) {
    return JSON.parse(JSON.stringify(theme, replacer));
}
export var ThemeProvider = function (_a) {
    var children = _a.children, _b = _a.theme, theme = _b === void 0 ? {} : _b;
    var mergedTheme = merge(defaultTheme, theme);
    return (React.createElement(StyledComponentsThemeProvider, { theme: mergedTheme },
        React.createElement(React.Fragment, null,
            children,
            React.createElement(GlobalStyle, null))));
};
export default ThemeProvider;
//# sourceMappingURL=index.js.map